import { typesGlob } from "../types";

const rootArea = "/subjects";

export const subjectGlob = () => ({
	self: rootArea,
	byType: (type: string) => ({ 						
		assigned: typesGlob(`${rootArea}/${type}/assigned`)
	})
});